module.exports = __webpack_public_path__ + "img/01.33ce4d14.jpg";